var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFmsAlgorithms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "g8v82pnb4a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15405",
    transform: "translate(518 2738)",
    style: {
      fill: "#ff2e2e",
      opacity: 0.158
    },
    d: "M0 0h180v180H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "algorithms_icon",
    transform: "translate(-518 -2738)",
    style: {
      clipPath: "url(#g8v82pnb4a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 702",
    transform: "translate(57.587 464.791)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 100",
    cx: 7.632,
    cy: 7.632,
    r: 7.632,
    transform: "translate(544.743 2341.95)",
    style: {
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59596",
    d: "M51.951 49.538v-5.89a.676.676 0 0 0-.676-.676H47.12a.677.677 0 0 1-.645-.491 14.276 14.276 0 0 0-1.135-2.746.674.674 0 0 1 .109-.8l2.936-2.937a.676.676 0 0 0 0-.956l-4.166-4.166a.678.678 0 0 0-.956 0l-2.937 2.934a.674.674 0 0 1-.8.109 14.362 14.362 0 0 0-2.746-1.136.675.675 0 0 1-.491-.644v-4.155a.676.676 0 0 0-.676-.676h-5.892a.675.675 0 0 0-.676.676v4.154a.675.675 0 0 1-.491.644 14.363 14.363 0 0 0-2.746 1.136.674.674 0 0 1-.8-.109l-2.936-2.937a.68.68 0 0 0-.958 0l-4.165 4.166a.676.676 0 0 0 0 .956l2.936 2.937a.674.674 0 0 1 .109.8 14.363 14.363 0 0 0-1.136 2.746.675.675 0 0 1-.644.491h-4.157a.676.676 0 0 0-.676.676v5.891a.677.677 0 0 0 .676.676h4.154a.675.675 0 0 1 .644.49 14.374 14.374 0 0 0 1.136 2.747.674.674 0 0 1-.109.8l-2.935 2.942a.676.676 0 0 0 0 .956l4.165 4.166a.677.677 0 0 0 .958 0l2.936-2.936a.674.674 0 0 1 .8-.11 14.28 14.28 0 0 0 2.747 1.134.675.675 0 0 1 .491.645V65.2a.676.676 0 0 0 .676.676h5.891a.677.677 0 0 0 .676-.676v-4.153a.675.675 0 0 1 .491-.645 14.28 14.28 0 0 0 2.746-1.136.674.674 0 0 1 .8.11l2.936 2.936a.676.676 0 0 0 .956 0l4.166-4.166a.676.676 0 0 0 0-.956l-2.936-2.936a.674.674 0 0 1-.109-.8 14.287 14.287 0 0 0 1.138-2.754.678.678 0 0 1 .645-.49h4.154a.677.677 0 0 0 .677-.672z",
    transform: "translate(519.71 2302.99)",
    style: {
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59597",
    d: "M67.481 49.479a31.929 31.929 0 1 1-31.93-31.93 31.93 31.93 0 0 1 31.93 31.93z",
    transform: "translate(516.823 2300.104)",
    style: {
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59598",
    d: "M45.49 20.026V25.1h-5.256",
    transform: "translate(527.651 2300.836)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59599",
    d: "M45.933 64.941h-5.076v-5.257",
    transform: "translate(527.836 2312.565)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59600",
    d: "M1 43.488 4.589 39.9l3.718 3.718",
    transform: "translate(516.048 2306.714)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 111",
    transform: "translate(552.375 2302.751)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M0 0v14.909"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 101",
    cx: 3.272,
    cy: 3.272,
    r: 3.272,
    transform: "translate(549.104 2296.209)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59601",
    d: "M21.937 22.6v-8.955l-5.9-7.824",
    transform: "translate(520.496 2296.635)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 102",
    cx: 3.272,
    cy: 3.272,
    r: 3.272,
    transform: "translate(530.791 2296.209)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59602",
    d: "M35.937 22.6v-8.955l5.9-7.824",
    transform: "translate(526.381 2296.635)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 103",
    cx: 3.272,
    cy: 3.272,
    r: 3.272,
    transform: "translate(567.416 2296.209)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 112",
    transform: "translate(552.375 2381.511)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M0 0v10.882"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 113",
    transform: "translate(534.064 2420.119)",
    style: {
      strokeWidth: "2.001px",
      strokeLinejoin: "round",
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M4.303 1.431 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59606",
    d: "M18.906 95.74v-11l20.437-7.277",
    transform: "translate(521.344 2317.823)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59603",
    d: "m31.711 112.518-20.846-6.944V80.4l20.846 6.94z",
    transform: "translate(518.966 2318.691)",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59604",
    d: "m26.95 112.518 20.85-6.944V80.4l-20.85 6.94z",
    transform: "translate(523.723 2318.691)",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59605",
    d: "m31.711 74.744-20.846 7.325 20.846 6.944 20.846-6.944z",
    transform: "translate(518.966 2317.02)",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFmsAlgorithms);
export default __webpack_public_path__ + "static/media/ico_fms_algorithms.827fa74e05dcce266118d65692db523e.svg";
export { ForwardRef as ReactComponent };